import React from 'react';
import PropTypes from 'prop-types'

export default function CircleCheckmarkFill({ fill })
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="12 0 99 90" xmlSpace="preserve" fill={fill}>
			<path id="Fill-v2_7_" d="M52,13.5c-19.9,0-36,16.1-36,36c0,19.9,16.1,36,36,36c19.9,0,36-16.1,36-36C88,29.6,71.9,13.5,52,13.5z
	 M47.5,64.9L34,51.3l6.4-6.4l7.2,7.2l18-18l6.4,6.4L47.5,64.9z"/>
		</svg>
	)
}

CircleCheckmarkFill.propTypes = {
  fill: PropTypes.string
};